import { render } from "./profileUpload.vue?vue&type=template&id=5b26926c"
import script from "./profileUpload.vue?vue&type=script&lang=js"
export * from "./profileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__